import * as React from 'react'

import { XIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import { ISharedSitePermit } from '~/client/graph/types.generated'
import desktopRoutes from '~/client/src/desktop/constants/desktopRoutes'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import { Button } from '~/client/src/shared/components/Button/Button'
import { SharedEntityActionTypes } from '~/client/src/shared/components/SharedEntityActions/SharedEntityActions'
import SharedPermitActions from '~/client/src/shared/components/SharedEntityActions/SharedPermitActions'
import { getTransitionPath } from '~/client/src/shared/constants/commonRoutes'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import SharedSitePermitStore from '~/client/src/shared/stores/domain/SharedSitePermit.store'

// localization: translated

interface IProps {
  state?: DesktopInitialState

  sharedSitePermitStore?: SharedSitePermitStore
  id: string
  onClose: () => void
}

@inject('sharedSitePermitStore', 'state')
@observer
export default class LogisticsActionSideWrapper extends React.Component<IProps> {
  private handleLinkClick = (e: React.MouseEvent, url: string) => {
    e.preventDefault()
    if (url) {
      window.open(url, '_blank')
    }
  }

  private handleCallTo = (email: string) => {
    if (email) {
      window.location.href = `tel:${email}`
    }
  }

  private handleMailTo = (email: string) => {
    if (email) {
      window.location.href = `mailto:${email}`
    }
  }

  private handleActionClick = (
    actionType: SharedEntityActionTypes,
    sharedPermit: ISharedSitePermit,
    e: React.MouseEvent,
  ) => {
    const { responsible, projectUrl, locationUrl } = sharedPermit
    switch (actionType) {
      case SharedEntityActionTypes.GO_TO_PROJECT:
        this.handleLinkClick(e, projectUrl)
        break
      case SharedEntityActionTypes.GO_TO_TO_LOCATION:
        this.handleLinkClick(e, locationUrl)
        break
      case SharedEntityActionTypes.CALL_ADMIN:
        this.handleCallTo(responsible?.phoneNumber)
        break
      case SharedEntityActionTypes.MAIL_ADMIN:
        this.handleMailTo(responsible?.email)
        break
      case SharedEntityActionTypes.GO_TO_SETTINGS:
        this.handleLinkClick(e, this.settingUrl)
        break
    }
  }

  private renderSharedLogisticsActions = () => {
    const sharedPermit = this.props.sharedSitePermitStore.list.find(
      d => d.id === this.props.id,
    )
    if (!sharedPermit) return null

    return (
      <SharedPermitActions
        entity={sharedPermit}
        companyName={sharedPermit.companyName}
        onActionClick={this.handleActionClick}
        projectId={sharedPermit.projectFromId}
      />
    )
  }

  public render() {
    return (
      <div className="logistics-action-side-wrapper">
        {this.renderSharedEntityHeader()}
        {this.renderSharedLogisticsActions()}
      </div>
    )
  }

  private renderSharedEntityHeader = () => {
    return (
      <div className="row tw:p-2.5 tw:pl-5 bb-light-grey">
        <Button
          variant="ghost"
          size="icon-sm"
          className="tw:flex-none! tw:self-center"
          aria-label={Localization.translator.close}
          onClick={this.props.onClose}
        >
          <XIcon />
        </Button>
        <div className="col x-center tw:ml-2.5 tw:mr-[30px]">
          <div className="text large">
            {Localization.translator.workflowDetails}
          </div>
        </div>
      </div>
    )
  }

  public get settingUrl(): string {
    return (
      location.origin +
      getTransitionPath(
        desktopRoutes.PROJECT_DETAILS,
        this.props.state.activeProject.code,
      )
    )
  }
}
